<script>
    import chooseSeasonFromText from "../../../lib/chooseSeason";

    export let data
</script>


<a href="#/produkt/{data?.product_id}" target="_blank" class="product">
    <div class="product-image">
        <img src={data?.detail?.picture || "/assets/img/nahled.webp"} alt="Fotografia pneumatiky">
    </div>
    <div class="product-text">
        <div class="product-logo">
            {#if data?.detail?.manufacturer_logo}
                <img src={data?.detail?.manufacturer_logo} alt={data?.detail?.manufacturer}>
            {:else}
                <span>{data?.detail?.manufacturer || ""}</span>
            {/if}
        </div>
        <div class="product-name">{data?.detail?.name || ''}</div>
        <div class="product-info">
            <div class="product-details">
                {@html chooseSeasonFromText(data?.detail?.season || null)}
                <div class="detail-item">{data?.detail?.width || '-'}</div>
                <div class="detail-item">{data?.detail?.profile || '-'}</div>
                <div class="detail-item">{data?.detail?.diameter || '-'}</div>
            </div>
        </div>
        <div class="product-count">{data.product_quantity}ks</div>
    </div>
    <div class="product-right">
        <div class="product-price">{(data.product_price * data.product_quantity || 0)?.toFixed(2)}€</div>
    </div>
</a>


<style>
    .product {
        color: black;
        display: flex;
        flex-direction: row;
        border: 1px solid var(--color-slate-200);
        border-radius: 1.5rem;
        padding: 1rem;
        margin-bottom: 1rem;
        transition: .2s linear;
    }
    .product:last-child {
        margin-bottom: 1.5rem;
    }
    .product .product-logo {
        display: flex;
        align-items: start;
        height: 2.5rem;
        margin-top: .75rem;
    }
    .product .product-logo img {
        max-width: 8rem;
        max-height: 1.5rem;
    }
    .product .product-logo span {
        font-family: Rubik, sans-serif;
        font-weight: 500;
        font-size: 1.3rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .product .product-image {
        width: 7.5rem;
        height: 7.5rem;
        display: grid;
        place-items: center;
        border: 1px solid var(--color-slate-200);
        border-radius: 1rem;
    }
    .product .product-image img {
        max-width: 6rem;
        max-height: 6rem;
        margin: .5rem;
    }
    .product .product-text {
        margin-left: 1rem;
        width: 40%;
    }
    .product .product-text .product-name {
        font-family: SegoeUI, sans-serif;
        margin-top: -15px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
        max-width: 100%;
        color: var(--color-slate-500);
    }
    .product .product-text .product-name a {
        color: black;
    }
    .product .product-text .product-details {
        display: flex;
        flex-direction: row;
        justify-content: start;
        place-items: center;
        font-family: Rubik, sans-serif;
        font-weight: 500;
        padding: 4px 0;
        margin-bottom: .25rem;
    }
    .product .product-text .product-details div {
        border-right: 2px solid var(--color-slate-200);
        color: var(--color-slate-600);
        font-size: 1rem;
        padding: 0 0.5rem;
    }
    .product .product-text .product-details div:last-child {
        border: 0;
    }
    .product .product-count {
        font-weight: 700;
        color: var(--color-slate-600);
    }
    .product-right {
        margin-left: auto;
        margin-right: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .product-right .product-price {
        font-family: Rubik, sans-serif;
        font-weight: 600;
        color: var(--color-secondary);
        font-size: 1.4rem;
        margin-top: 2.8rem;
    }
    @media (max-width: 768px) {
        .product .product-image {
            display: none;
        }
        .product .product-text {
            margin-left: 0;
        }
    }
</style>